import React from "react";
import {useSelector} from "react-redux";
import {useLocation} from "react-router";

import {ChevronLeftIcon, ChevronRightIcon} from "@pg-design/icons-module";
import {PaginationSize, PaginationWithList} from "@pg-design/pagination";
import {appendQueryString, parseSearch, validateQuery} from "@pg-mono/request";
import {useUserDevice} from "@pg-mono/user-device";

import {IRPStore} from "../../../app/rp_reducer";
import {OFFER_LIST_PAGE_SIZE} from "../../../offer/list/constants/offer_list";

export const InvestmentOfferListPagination = () => {
    const location = useLocation();
    const {isMobile} = useUserDevice();

    const count = useSelector((state: IRPStore) => state.investmentOffer.list.offers.count);

    const buildPageLink = (page: number) => {
        const query = validateQuery(["page"], parseSearch(location.search), page >= 2 ? {page: page.toString()} : {});

        return appendQueryString(location.pathname, query) + location.hash;
    };

    const query = parseSearch(location.search);
    const currentPage = typeof query.page === "string" ? parseInt(query.page, 10) : 1;
    const maxPage = count ? Math.ceil(count / OFFER_LIST_PAGE_SIZE) : 1;

    return (
        <PaginationWithList
            hrefBuilder={buildPageLink}
            iconPrev={<ChevronLeftIcon />}
            iconNext={<ChevronRightIcon />}
            pageCount={maxPage}
            currentPage={currentPage}
            multiNumbersInside
            size={isMobile ? PaginationSize.SM : PaginationSize.LG}
        />
    );
};
import React from "react";
import {useSelector} from "react-redux";
import {useLocation} from "react-router";

import {ChevronLeftIcon, ChevronRightIcon} from "@pg-design/icons-module";
import {PaginationSize, PaginationWithList} from "@pg-design/pagination";
import {appendQueryString, parseSearch, validateQuery} from "@pg-mono/request";
import {useUserDevice} from "@pg-mono/user-device";

import {IRPStore} from "../../../app/rp_reducer";
import {OFFER_LIST_PAGE_SIZE} from "../../../offer/list/constants/offer_list";

export const InvestmentOfferListPagination = () => {
    const location = useLocation();
    const {isMobile} = useUserDevice();

    const count = useSelector((state: IRPStore) => state.investmentOffer.list.offers.count);

    const buildPageLink = (page: number) => {
        const query = validateQuery(["page"], parseSearch(location.search), page >= 2 ? {page: page.toString()} : {});

        return appendQueryString(location.pathname, query) + location.hash;
    };

    const query = parseSearch(location.search);
    const currentPage = typeof query.page === "string" ? parseInt(query.page, 10) : 1;
    const maxPage = count ? Math.ceil(count / OFFER_LIST_PAGE_SIZE) : 1;

    return (
        <PaginationWithList
            hrefBuilder={buildPageLink}
            iconPrev={<ChevronLeftIcon />}
            iconNext={<ChevronRightIcon />}
            pageCount={maxPage}
            currentPage={currentPage}
            multiNumbersInside
            size={isMobile ? PaginationSize.SM : PaginationSize.LG}
        />
    );
};
